<div id="firebaseui-auth-container"></div>
<p class="firebaseui-tos firebaseui-tospp-full-message" style="width: 100%; text-align: center">
  <a href="/public/imprint" class="firebaseui-link firebaseui-pp-link" i18n="@@Imprint" target="_blank">Imprint</a></p>
